module.exports = __webpack_public_path__ + "static/ip-ikon4-48971d0c809fa03135bf54d8285ad0d0.png";